// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.apex-download-options {\n  display: none;\n}\n@media screen and (min-width: 1216px) {\n.apex-download-options {\n      display: flex;\n}\n}\n", ""]);
// Exports
module.exports = exports;
